import React from "react";
import { Box, Button, Text, Spinner, ModalBody, ModalFooter } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ChakraFAIcon } from "@/components/ui/Icon";
import { ClasswizeModal } from "@/components/ui/Modal";

interface Props {
	name: string;
	isDeleting: boolean;
	isOpen: boolean;
	closeModal: () => void;
	handleConfirmDelete: () => void;
}
export function ConfirmDeleteFocusModal(props: Props): JSX.Element {
	const { t } = useTranslation();
	return (
		<ClasswizeModal isOpen={props.isOpen} onClose={props.closeModal} title={t("focusLibrary.deleteModalTitle")} size="lg">
			<ModalBody>
				<Text my={4}>{t("focusLibrary.deleteModalBody", { name: props.name })}</Text>
			</ModalBody>
			<ModalFooter>
				<Box>
					<Button
						variant="danger"
						leftIcon={props.isDeleting ? <Spinner /> : <ChakraFAIcon icon={"fa-trash-can"} variant="solid" />}
						float={"right"}
						onClick={props.handleConfirmDelete}
						isDisabled={props.isDeleting}
					>
						{props.isDeleting ? t("focusLibrary.deleteModalDeleting") : t("focusLibrary.deleteModalDelete")}
					</Button>
				</Box>
			</ModalFooter>
		</ClasswizeModal>
	);
}
